import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { axiosGet } from '../../common/js/axios-utility';
import { type DownloadFile } from '../models/types';
import { getMatches } from '../js/download-match-utility';
import { DownloadsContext } from '../contexts/DownloadsContext';
import DownloadTable from './DownloadTable';
import Filters from './filters/Filters';
import { setUrl } from '../js/downloads-utility';

type Props = {}

export default function Downloads({}: Props) {
    const downloadData = useQuery({
        queryKey: ['downloads'], 
        queryFn: fetchDownloads, 
        refetchOnWindowFocus: false}
    );
    const downloads: DownloadFile[] = downloadData.data;
    const [downloadsState,] = React.useContext(DownloadsContext);
    const [filteredDownloads, setFilteredDownloads] = React.useState<DownloadFile[]>();

    React.useEffect(() => {
        const {filters} = downloadsState;
        const matches: DownloadFile[] = getMatches(downloads, downloadsState.filters);
        setFilteredDownloads(matches);
        setUrl(filters.family, filters.host, filters.os);
    }, [downloadData.data, downloadsState.filters]);

    return (
        <div className='downloads-container'>
            <Filters />
            <div className='downloads-table-container'>
                <DownloadTable downloads={filteredDownloads} fetching={downloadData.isFetching} />
            </div>
        </div>
    )
}

const fetchDownloads = async (): Promise<DownloadFile[]> => {
    const { data } = await axiosGet('/downloads');
    return data;
}